<template>
  <div class="risk-control-statistics">
    <div class="app-panel search-panel blank-h">
      <div class="app-control app-table-control">
        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodOne" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" clearable></el-date-picker>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <div class="app-panel blank-v blank-h panel-1">
      <p class="app-title mb">风控综合指标</p>
      <div class="wrap">
        <div class="item">
          <p>{{panelOneValueOne}}</p>
          <p>签约合同数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueTwo}}</p>
          <p>系统判定正常签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueThree}}</p>
          <p>待网批正常签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueFour}}</p>
          <p>网批中正常签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueFive}}</p>
          <p>网批正常签约</p>
        </div>
      </div>
      <div class="wrap">
        <div class="item">
          <p>{{panelOneValueSix}}</p>
          <p>认证次数</p>
        </div>
        <div class="item">
          <p>{{panelOneValueSeven}}</p>
          <p>系统判定风险签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueEight}}</p>
          <p>待网批风险签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueNine}}</p>
          <p>网批中风险签约</p>
        </div>
        <div class="item">
          <p>{{panelOneValueTen}}</p>
          <p>网批风险签约</p>
        </div>
      </div>
    </div>
    <div class="app-panel blank-v blank-h panel-2">
      <p class="app-title mb">近30天渠道风控趋势</p>
      <ve-line :data="chartOne.datas" :colors="chartOne.colors"></ve-line>
    </div>
    <div class="app-panel blank-v blank-h panel-3">
      <p class="app-title mb">风险指标分布</p>
      <ve-ring :data="chartTwo.datas" :colors="chartTwo.colors" :legend="chartTwo.legend"></ve-ring>
    </div>
    <div class="app-panel blank-v blank-h panel-4">
      <p class="app-title mb">风险签约占比</p>
      <ve-ring :data="chartThree.datas" :colors="chartThree.colors" :legend="chartThree.legend"></ve-ring>
    </div>
    <div class="app-panel blank-v blank-h panel-5">
      <p class="app-title mb">风险渠道排行</p>
      <el-table :data="tableDatasOne" height="300">
        <el-table-column label="名称" prop="realtor_name"></el-table-column>
        <el-table-column label="类型" prop="realtor_type"></el-table-column>
        <el-table-column label="数量" prop="count"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import StatisticsService from '@/io/statistics.js';

  export default {
    name: 'RiskControlStatistics',
    data() {
      let self = this;
      return {
        search: {
          periodOne: null
        },
        pickerOptions: {
          shortcuts: [
            {
              text: '昨日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit('pick', [start, start]);
              }
            },
            {
              text: '近3日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近7日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近14日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '近30日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        panelOneValueOne: 0,
        panelOneValueTwo: 0,
        panelOneValueThree: 0,
        panelOneValueFour: 0,
        panelOneValueFive: 0,
        panelOneValueSix: 0,
        panelOneValueSeven: 0,
        panelOneValueEight: 0,
        panelOneValueNine: 0,
        panelOneValueTen: 0,
        chartOne: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#9A6AFF', '#2EBFFB'],
        },
        chartTwo: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#3BA0FF', '#36CBCB', '#4DCB73', '#FAD337', '#F2637B', '#975FE4'],
          legend: {
            orient: 'vertical',
            x: 'right'
          }
        },
        chartThree: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#9A6AFF', '#2EBFFB'],
          legend: {
            orient: 'vertical',
            x: 'right'
          }
        },
        tableDatasOne: []
      }
    },
    mounted () {
      this.initDatas();
      StatisticsService.monthRiskTrend().then(res => {
        this.chartOne.datas = {
          columns: ['日期', '正常签约', '风险签约'],
          rows: res.data.sign_statistic.map(val => {
            return {
              '日期': val.date,
              '正常签约': val.normal_sign_count,
              '风险签约': val.confirm_risk_sign_count
            }
          })
        };
      }).catch(() => {});
    },
    methods: {
      initDatas() {
        StatisticsService.risk(
          this.search.periodOne ? this.search.periodOne[0] : '',
          this.search.periodOne ? this.search.periodOne[1] : '',
        ).then(res => {
          this.panelOneValueOne = res.data.sign_count;
          this.panelOneValueTwo = res.data.system_judgment_normal_sign_count;
          this.panelOneValueThree = res.data.pd_net_audit_ready_normal_sign_count;
          this.panelOneValueFour = res.data.pd_net_auditing_normal_sign_count;
          this.panelOneValueFive = res.data.pd_net_audit_normal_sign_count;
          this.panelOneValueSix = res.data.contract_count;
          this.panelOneValueSeven = res.data.system_judgment_risk_sign_count;
          this.panelOneValueEight = res.data.pd_net_audit_ready_risk_sign_count;
          this.panelOneValueNine = res.data.pd_net_auditing_risk_sign_count;
          this.panelOneValueTen = res.data.pd_net_audit_risk_sign_count;
          this.chartTwo.datas = {
            columns: ['指标', '数量'],
            rows: res.data.risk_signing_types_statistic.map(val => {
              return {
                '指标': val.name,
                '数量': val.count,
              }
            })
          };
          this.chartThree.datas = {
            columns: ['指标', '数量'],
            rows: [
              {
                '指标': '正常签约',
                '数量': res.data.sign_statistic_percent.normal_sign,
              },
              {
                '指标': '风险签约',
                '数量': res.data.sign_statistic_percent.risk_sign,
              }
            ]
          };
          this.tableDatasOne = res.data.realtor_names_rank;
        }).catch(() => {});
      },
      searchParams() {
        this.initDatas();
      },
      resetParams() {
        this.search.periodOne = null;
        this.searchParams();
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .risk-control-statistics {
    margin: -10px;
    .app-panel {
      box-shadow: @box-shadow-1;
      float: left;
      margin: 10px;
      &.search-panel {
        width: calc(100% - 60px);
      }
      &.panel-1 {
        width: calc(100% - 60px);
        .wrap {
          display: flex;
          text-align: center;
          &:not(:last-of-type) {
            margin-bottom: 20px;
          }
          .item {
            flex: 1;
            p {
              &:nth-of-type(1) {
                font-size: 40px;
                margin-bottom: 10px;
                color: @color-primary;
              }
              &:nth-of-type(2) {
                color: @color-text-3;
              }
            }
          }
        }
      }
      &.panel-2 {
        width: calc(100% - 60px);
      }
      &.panel-3,
      &.panel-4 {
        width: calc(100%/2 - 60px);
      }
      &.panel-5 {
        width: calc(100% - 60px);
      }
    }
  }
</style>